import { ActionGroup } from "@mittwald/flow-remote-react-components";
import { Button } from "@mittwald/flow-remote-react-components";
import { typedList } from "@mittwald/flow-remote-react-components";
import { ModalTrigger } from "@mittwald/flow-remote-react-components";
import CreateUserModal from "./CreateUserModal";
import { useListUsers } from "../../hooks/useListUsers";
import { NoUsers } from "./NoUsers";
import { UserListItem } from "./UserListItem.tsx";

export const UserList = (props: { projectId: string }) => {
  const UserList = typedList<{
    username: string;
  }>();

  const users = useListUsers(props.projectId);
  const usersListData = users.data.map((user) => ({
    username: user.username,
  }));

  if (users.data.length == 0) {
    return <NoUsers projectId={props.projectId} />;
  }

  return (
    <>
      <UserList.List>
        <UserList.StaticData data={usersListData} />
        <UserList.Sorting
          property="username"
          name="Name A bis Z"
          direction="asc"
          defaultEnabled
        />
        <UserList.Sorting
          property="username"
          name="Name Z bis A"
          direction="desc"
        />
        <ActionGroup>
          <ModalTrigger>
            <Button color="success">Benutzer anlegen</Button>
            <CreateUserModal projectId={props.projectId} />
          </ModalTrigger>
        </ActionGroup>
        <UserList.Search />
        <UserList.Item>
          {(user) => <UserListItem user={user} projectId={props.projectId} />}
        </UserList.Item>
      </UserList.List>
    </>
  );
};
